import axios from "axios";
import store from "../store";
var instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "/api"
      : `${window.location.protocol}//${window.location.host}`,
  headers: { "Content-Type": "application/json;charset=UTF-8" },
});
instance.interceptors.request.use(
  function (config) {
    config.url = "/v1/api" + config.url;
     // 从本地存储中获取 token
     const token = store.getters['user/getToken']
     if (token) {
      config.headers['user-token'] = `${token}` 
     }else{
      location.href='/#/login'
      store.commit('user/LOG_OUT')
      location.reload()
      Message({
        type: "info",
        message: '没有token请重新登录'
      });
     }
    return config;
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
export default instance;
